import { Row, Tabs } from 'antd'
import { useState } from 'react'

import { TeamMember } from './TeamMember'

export const MeetTheTeam = () => {
  const [activeTab, setActiveTab] = useState('leadership')

  return (
    <div className='container section'>
      <h1 className='text-center'>Meet the Team</h1>
      <div className='section-inner'>
        <Tabs
          activeKey={activeTab}
          onChange={(tab) => setActiveTab(tab)}
          centered
          tabBarStyle={{ marginBottom: '3rem' }}
        >
          <Tabs.TabPane tab='Leadership' key='leadership' forceRender>
            <Row justify='center' gutter={[32, 32]}>
              <TeamMember
                fileName='swamy'
                name='Dr. Ganesh Swamy'
                credentials='Program Lead'
                link='/about/message'
              />
              <TeamMember
                fileName='lewkonia'
                name='Dr. Peter Lewkonia'
                credentials='Clinical Lead'
                link='/about/message'
              />
              <TeamMember
                fileName='evaniew'
                name='Dr. Nathan Evaniew'
                credentials='Research Director'
                link='/research/roadmap'
              />
              <TeamMember
                fileName='nicholls'
                name='Dr. Fred Nicholls'
                credentials='Fellowhip Director'
                link='/fellowship/message'
              />
            </Row>
          </Tabs.TabPane>
          <Tabs.TabPane tab='Surgeons' key='surgeons'>
            <Row justify='center' gutter={[32, 32]}>
              <TeamMember
                fileName='cadotte'
                name='Dr. David W. Cadotte'
                credentials='MD PhD FRCSC'
                location='Neurological Spine Surgery'
              />
              <TeamMember
                fileName='casha'
                name='Dr. Steph Casha'
                credentials='MD PhD FRCSC'
                location='Neurological Spine Surgery'
              />
              <TeamMember
                fileName='chan'
                name='Dr. Vivien Chan'
                credentials='MD MSc FRCSC'
                location='Pediatric Neurological Spine Surgery'
              />
              <TeamMember
                fileName='evaniew'
                name='Dr. Nathan Evaniew'
                credentials='MD PhD FRCSC'
                location='Orthopedic Spine Surgery'
              />
              <TeamMember
                fileName='hu'
                name='Dr. Rick Hu'
                credentials='MD FRCSC'
                location='Orthopedic Spine Surgery'
              />
              <TeamMember
                fileName='larouche'
                name='Dr. Jeremie Larouche'
                credentials='MD MSc FRCSC'
                location='Orthopedic Spine Surgery'
              />
              <TeamMember
                fileName='lewkonia'
                name='Dr. Peter Lewkonia'
                credentials='MD MSc FRCSC'
                location='Orthopedic Spine Surgery'
              />
              <TeamMember
                fileName='nicholls'
                name='Dr. Fred Nicholls'
                credentials='MD MA FRCSC'
                location='Orthopedic Spine Surgery'
              />
              <TeamMember
                fileName='parsons'
                name='Dr. David Parsons'
                credentials='MD FRCSC'
                location='Pediatric Orthopedic Spine Surgery'
              />

              <TeamMember
                fileName='soroceanu'
                name='Dr. Alex Soroceanu'
                credentials='MD CM MPH FRCSC'
                location='Orthopedic Spine Surgery'
              />
              <TeamMember
                fileName='swamy'
                name='Dr. Ganesh Swamy'
                credentials='MD PhD FRCSC'
                location='Orthopedic Spine Surgery'
              />
              <TeamMember
                fileName='thomas'
                name='Dr. Ken Thomas'
                credentials='MD MHSc FRCSC'
                location='Orthopedic Spine Surgery'
              />

              <TeamMember
                fileName='m_yang'
                name='Dr. Michael Yang'
                credentials='MD MSc M.Biotech FRCSC'
                location='Neurological Spine Surgery'
              />
            </Row>
          </Tabs.TabPane>
          <Tabs.TabPane tab='Specialized Team' key='specialized'>
            <h3 className='text-center'>Research Team</h3>
            <Row justify='center' gutter={[32, 32]}>
              <TeamMember
                fileName='whittaker'
                name='Tara Whittaker'
                credentials='RN BN CCRC & Photographer'
                location='Research Team Manager'
              />
              <TeamMember
                fileName='tripathy'
                name='Saswati Tripathy'
                credentials='RA PhD'
                location='Research Team'
              />
              <TeamMember
                fileName='smith'
                name='Vicki Smith'
                credentials='PhD'
                location='Research Team'
              />
              <TeamMember
                fileName='masson'
                name='Anand Oliveira Masson'
                credentials='PhD'
                location='Research Team'
              />
              <TeamMember
                fileName='jamani'
                name='Naila Jamani'
                credentials='MSc'
                location='Research Team'
              />

              <TeamMember
                fileName='vandergaag'
                name='Isabella Vandergaag'
                credentials='MSc EIT'
                location='Research Team'
              />
              <TeamMember
                fileName='babu'
                name='Maria Babu'
                credentials='MSc'
                location='Research Team'
              />
            </Row>
            <br />
            <h3 className='text-center'>Complex Spine Anesthesia Group</h3>
            <Row justify='center' gutter={[32, 32]}>
              <TeamMember
                fileName='bennitz'
                name='Dr. Joshua Bennitz'
                credentials='MD FRCPC'
                location='Complex Spine Anesthesia Group'
              />
              <TeamMember
                fileName='rogan'
                name='Dr. Kyle Rogan'
                credentials='MD FRCPC'
                location='Complex Spine Anesthesia Group'
              />
              <TeamMember
                fileName='dyte'
                name='Dr. Chris Dyte'
                credentials='MD BScH FRCPC'
                location='Complex Spine Anesthesia Group'
              />
            </Row>
            <br />
            <h3 className='text-center'>Cascade Orthotics</h3>
            <Row justify='center' gutter={[32, 32]}>
              <TeamMember
                fileName='wright'
                name='Jeff Wright'
                credentials='Certified Orthotist'
                location='Cascade Orthotics'
              />
              <TeamMember
                fileName='cameron'
                name='Rob Cameron'
                credentials='Certified Orthotist'
                location='Cascade Orthotics'
              />
              <TeamMember
                fileName='anholt'
                name='Drew Anholt'
                credentials='Certified Orthotist'
                location='Cascade Orthotics'
              />
            </Row>
            <br />
            <h3 className='text-center'>Nurse Practitioners</h3>
            <Row justify='center' gutter={[32, 32]}>
              <TeamMember
                fileName='prince'
                name='Ron Prince'
                credentials='Nurse Practitioner'
                location='Neurological Spine Surgery'
              />
              <TeamMember
                fileName='miller'
                name='Nicole Miller'
                credentials='Nurse Practitioner'
                location='Orthopedic Spine Surgery'
              />
              <TeamMember
                fileName='abshar'
                name='Sadaf Abshar'
                credentials='Nurse Practitioner'
                location='Neurological Spine'
              />
              <TeamMember
                fileName='laude'
                name='Kristen Laude'
                credentials='Nurse Practitioner'
                location='Orthopedic Spine Surgery
'
              />
            </Row>
            <br />
            <h3 className='text-center'>Physician Assistants</h3>
            <Row justify='center' gutter={[32, 32]}>
              <TeamMember
                fileName='marquez'
                name='Franklin Marquez'
                credentials='CCPA CPSA AAPA-F BSc'
                location='Orthopedic Trauma Physician Assistant
'
              />
            </Row>
            <br />
            <h3 className='text-center'>Nursing Staff</h3>
            <Row justify='center' gutter={[32, 32]}>
              <TeamMember
                fileName='marsh'
                name='Chris Marsh'
                credentials='Nurse Clinician'
                location='Operating Room'
              />
              <TeamMember
                fileName='reader'
                name='Julie Reader'
                credentials='Clinical Nurse Educator'
                location='Unit 101'
              />
              <TeamMember
                fileName='mcGuire'
                name='Shelly McGuire'
                credentials='Unit Manager'
                location='Unit 101'
              />
            </Row>
            <br />
            <h3 className='text-center'>ERAS Team (Enhanced Recovery After Surgery)</h3>
            <Row justify='center' gutter={[32, 32]}>
              <TeamMember
                fileName='m_yang'
                name='Dr. Michael Yang'
                credentials='Neurosurgeon'
              />
              <TeamMember
                fileName='lewkonia'
                name='Dr. Peter Lewkonia'
                credentials='Orthopedic Surgeon'
              />
              <TeamMember
                fileName='simms'
                name='Sierra Nash'
                credentials='Nurse Navigator (on leave)'
              />
              <TeamMember
                fileName='masson'
                name='Anand Oliveira Masson'
                credentials='Research Coordinator'
              />
              <TeamMember
                fileName='pratt'
                name='Brandy Pratt'
                credentials='Lead Analyst'
              />
              <TeamMember
                fileName='makhotkina'
                name='Brittney Makhotkina'
                credentials='Nurse Navigator'
              />
            </Row>
            <br />
            <h3 className='text-center'>Administration</h3>
            <Row justify='center' gutter={[32, 32]}>
              <TeamMember
                fileName='manjeya'
                name='Noma Manjeya'
                credentials='Program Administrator'
              />
            </Row>
          </Tabs.TabPane>
        </Tabs>
      </div>
    </div>
  )
}
